module.exports = "/_next/static/images/1-f03109a4490c76b9bb5ffd7aace89df6.jpg";